import type { SolcatcherConfig } from "./types.js";

export const defaultConfig: SolcatcherConfig = {
  autoLoadEnv: true,
};
